import React from 'react';

const NavLink = ({ label, href, onClick , active, isMobile}) => (
  <a
    className="nav-link px-3 py-1 mx-0 mx-md-4"
    href={href || '#'}
    onClick={(e) => { e.preventDefault(); if (onClick) onClick(); }}
    style={{ 
      color: label == 'CBrainAI'? '#ffc107': active ? 'white' : '#b5b5b5', 
      textDecoration: 'none', 
      borderRadius:'0px', 
      fontWeight:'600', 
      fontFamily:"'Inter', serif", 
      borderBottom: active ?'2px solid #ffc107':'0px', 
      fontSize: isMobile?'14px':'16px',
      textShadow: (label == 'CBrainAI') ? 'rgb(0 0 0 / 45%) 0px 3px 5px' : 'none'

    }}

    >
    {label ==='CBrainAI' && (!isMobile && <i className="bi bi-gear-fill"> </i>)}{label}
  </a>
);

export default NavLink;
